<template>
  <StudioPagination
    v-if="totalCount > pageSize"
    :itemsPerPageCount="pageSize"
    :itemsCount="totalCount"
    :currentPage="currentPage"
    suffix="Videos"
    @next="onNext"
    @previous="onPrevious"
    @goToFirstPage="onGoToFirstPage"
    @goToLastPage="onGoToLastPage"
  />
</template>

<script setup lang="ts">
import StudioPagination from '@/studioComponents/StudioPagination.vue';

const props = defineProps<{
  pageSize: number;
  totalCount: number;
  currentPage: number;
}>();

const emit = defineEmits<{
  (
    e: 'fetch',
    params: {
      firstLoad: boolean;
      currentPage: number;
    }
  ): void;
}>();

const onNext = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: props.currentPage + 1
  });
};

const onPrevious = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: props.currentPage - 1
  });
};

const onGoToFirstPage = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: 1
  });
};

const onGoToLastPage = () => {
  emit('fetch', {
    firstLoad: false,
    currentPage: Math.ceil(props.totalCount / props.pageSize)
  });
};
</script>
